<section class="form-section position-relative py-5" [ngStyle]="{'background-image': backgroundImageUrl}">
  <div class="overlay"></div> <!-- Gradient Overlay -->
  <div class="container position-relative">
    <div class="row justify-content-center align-items-center min-vh-75">

      <!-- Left Side: 7 Columns (Text with Gradient Background) -->
      <div class="col-lg-7 col-md-12 text-center text-md-start">
        <div class="p-4 text-white">
          <h1 class="fw-bold text-light">We help you achieve your <span class="text-warning">{{serviceName}}</span></h1>
          <p class="fs-5 text-light opacity-75">Let’s take the first step toward your goals.</p>
          <hr class="w-50 border-light">
          <a href="/contactUs" class="btn btn-outline-light mt-3">Schedule a Meeting</a>
        </div>
      </div>

      <!-- Right Side: 5 Columns (Enquiry Form) -->
      <div class="col-lg-5 col-md-12">
        <div class="p-4 shadow rounded bg-white">
          <h2 class="text-center text-primary fw-bold">GET IN TOUCH</h2>
          <h3 class="text-center text-muted mb-3">Start your journey today!</h3>

          <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-12 mb-2">
                <input type="text" formControlName="full_name" class="form-control" placeholder="Enter your Name"
                  required>
              </div>
              <div class="col-12 mb-2">
                <input type="email" formControlName="email" class="form-control" placeholder="Enter your Email"
                  required>
              </div>
              <div class="col-12 mb-2">
                <input type="tel" formControlName="phone" class="form-control" placeholder="Enter Phone Number"
                  required>
              </div>
              <div class="col-12 mb-2">
                <input type="datetime-local" formControlName="appointment_date" id="appointmentDate"
                  class="form-control" required>
              </div>
              <div class="col-12 mb-2">
                <textarea formControlName="enq_detail_msg" class="form-control" placeholder="Enter your Message"
                  rows="2" required></textarea>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-success w-100 py-2" [disabled]="!enquiryForm.valid">Submit</button>
              </div>
            </div>
          </form>

          <div *ngIf="submissionSuccess" class="alert alert-success mt-2">
            {{ successMessage }}
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
